import axios from 'axios';
import { logoutCustomer } from '../utils/auth';

// API Configuration
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "https://fhome-web-api-dev-cpefddczabfqcmhn.canadacentral-01.azurewebsites.net";

export const API_ENDPOINTS = {
  // Products
  GET_ALL_PRODUCTS: `${API_BASE_URL}/AddProduct/GetAllProducts`,
  GET_PRODUCTS: `${API_BASE_URL}/GetProducts/GetAllProducts`,
  
  // Categories
  GET_CATEGORIES: `${API_BASE_URL}/Categories/GetCategories`,
  
  // Cart
  CREATE_OR_ADD_CART_ITEM: `${API_BASE_URL}/Cart/CreateOrAddCartItem`,
  GET_CART_BY_CUSTOMER: `${API_BASE_URL}/Cart/GetCartByCustomerId`,
  UPDATE_QUANTITY: `${API_BASE_URL}/Cart/UpdateQuantity`,
  
  // Deals
  GET_DEALS: `${API_BASE_URL}/DealoftheDay/GetAllDeals`,
};

// Create axios instance with interceptor for Bearer token
export const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add request interceptor to include Bearer token
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('jwt');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Guard to prevent multiple simultaneous 401 redirects
let isHandling401 = false;

// Add response interceptor for error handling
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && !isHandling401) {
      isHandling401 = true;
      // Token expired or invalid — clear session and send to login
      logoutCustomer();
      window.location.replace('/login');
    }
    if (!error.response) {
      // Network error or no response from server
      console.error('Network Error:', error.message);
      console.error('Request config:', error.config);
    }
    return Promise.reject(error);
  }
);

export default API_BASE_URL;

